import React from 'react'
import { compose, graphql } from 'react-apollo'
import { Form, Select, Upload, Button, Col } from 'antd'
import Headroom from 'react-headroom'
import _get from 'lodash/get'
import PhotoList from './PhotoList'
// import EventPhotoList from './EventPhotoList'
import faceIndexedEventsQuery from '~/graphql/queries/faceIndexedEvents.gql'

import thairunLogo from '~/images/ThaiRun.png'
// import bs42Logo from '~/images/BANGSAEN42.png'
import trfLogo from '~/images/TRF.png'

import './App.css'
import { Header, Body, Footer, SelectImgButton } from './styles'
const fileReader = new FileReader()

const MAX_DIMENSION = 2400

const App = ({ form, data }) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form
  const { events = [] } = data

  const beforeUpload = function (file, files) {
    const img = new Image()
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    fileReader.onload = e => {
      img.src = fileReader.result
      img.onload = () => {
        const maxDim = img.width > img.height ? img.width : img.height
        // const ratio = (maxDim > MAX_DIMENSION ? MAX_DIMENSION : maxDim) / maxDim
        const ratio = MAX_DIMENSION / maxDim
        const width = img.width * ratio
        const height = img.height * ratio
        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, width, height)
        const imgUrl = canvas.toDataURL('image/jpeg', 0.95)
        // const imgUrl = canvas.toDataURL('image/jpeg')
        file.thumbUrl = imgUrl
        const [, mimeType, base64data] = imgUrl.match(/^data:(.+);base64,(.*)$/)

        setFieldsValue({
          refData: {
            mimeType,
            base64data,
            imgUrl
          }
        })
      }
    }
    fileReader.readAsDataURL(file)
    return false
  }

  const eventIdDecorator = getFieldDecorator('eventId', {
    initialValue: _get(events.slice(0).reverse(), [0, '_id'])
  })
  getFieldDecorator('refData')

  const eventId = getFieldValue('eventId')
  const refData = getFieldValue('refData')

  return (
    <Form layout="inline">
      <Headroom onPin={this.onPin} onUnpin={this.onUnpin}>
        <Header>
          <Col sm={10} xs={24}>
            <img src={thairunLogo} className="thairunLogo" alt="ThaiRun"/>
            <span className="title">FACE.THAI.RUN <strong>[Beta]</strong></span>
          </Col>
          <Col sm={14} xs={24}>
            <Form.Item style={{ margin: '8px' }}>
              {eventIdDecorator(
                <Select
                  showSearch
                  style={{ width: 200 }}
                  placeholder="Select Event"
                  optionFilterProp="children"
                  onChange={this.handleEventChange}
                  filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {events.slice(0).reverse().map(event =>
                    <Select.Option key={event._id} value={event._id}>{event.title}</Select.Option>
                  )}
                </Select>
              )}
            </Form.Item>
            <Form.Item style={{ margin: '8px' }}>
              <Upload 
                name="refData"
                action=""
                beforeUpload={beforeUpload}
                showUploadList={false}
              >
                <Button type="primary" size="large">ค้นภาพด้วยใบหน้า</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Header>
      </Headroom>
      <Body>
        {(eventId && refData) && <PhotoList eventId={eventId} refData={refData} /> }
      </Body>
      <Footer>
        <Col sm={{ push: 12, span: 12 }} xs={24} className="refImageCol">
        {refData
          && <SelectImgButton>
            <img src={refData.imgUrl} alt="reference preview" />
          </SelectImgButton>}
        </Col>
        <Col xs={24} className="sponsorCol" style={{ textAlign: 'center' }}>
          <div className="sponsorText">
            Face.Thai.Run partly funded by TRF
            <img src={trfLogo} alt="Thailand Research Fund (TRF)" />
          </div>
        </Col>
      </Footer>
    </Form>
  )
}

export default compose(
  Form.create(),
  graphql(faceIndexedEventsQuery)
)(App)



// WEBPACK FOOTER //
// ./src/App.jsx